module.exports = __webpack_public_path__ + "img/demandLogo.6e6bb2bd.png";